import MicroModal from 'micromodal';
import Swiper from 'swiper/bundle';

// import Masonry from 'masonry-layout/masonry';

import SwiperCore, {
    Autoplay,
    Navigation,
} from 'swiper/core';

import {
    adaptPackImg,
} from './packContainer';

const COOKIE_NAME = 'widereview_api';

SwiperCore.use([Autoplay, Navigation]);

function nl2br(str, isXhtml) {
    if (typeof str === 'undefined' || str === null) {
        return ''
    }

    const breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br ' + '/>' : '<br>'

    return (str + '')
        .replace(/(\r\n|\n\r|\r|\n)/g, breakTag + '$1')
}

export function initSwiper(container, reviewNumber, options, reviews) {
    let swiperContainer, breakpoints;
    let isMiniContainer = false;

    if (container && container.classList.contains('widereview-mini')) {
        swiperContainer = document.getElementById('widereview-swiper-containerSmallProductPage');
        isMiniContainer = true;
    } else {
        swiperContainer = document.getElementById('widereview-swiper-container');
    }

    if (!swiperContainer) return;
    let loopCondition,
        centeredSlidesCondition,
        centerInsufficientSlides;

    let virtualCondition = false;

    let intervalAutoSliding = 5000;

    if (reviewNumber === 1) {
        loopCondition =  false;
        centeredSlidesCondition = true;
        centerInsufficientSlides = false;
        breakpoints = {
            1: {
                slidesPerView: 'auto',
            }
        };
    } else if (reviewNumber >= 2 && reviewNumber <=3) {
        loopCondition =  false;
        centeredSlidesCondition = false;
        centerInsufficientSlides = true;
        breakpoints = {
            1: {
                slidesPerView: 'auto',
            }
        };
    } else {
        loopCondition =  true;
        centeredSlidesCondition = true;
        centerInsufficientSlides = false;
        breakpoints = {
            1: {
                slidesPerView: 'auto',
            }
        };
    }

    if (options.enable_auto_slide === false) {
        intervalAutoSliding = 31536000000;
    }

    if (reviewNumber >= 30 && !isMiniContainer) {
        loopCondition =  false;
        centeredSlidesCondition = false;
        centerInsufficientSlides = true;
        virtualCondition = true;
        breakpoints = {
            320: {
                centeredSlides: true,
                slidesPerView: 1.5,
            },
            440: {
                centeredSlides: false,
                slidesPerView: 2,
            },
            640: {
                centeredSlides: centeredSlidesCondition,
                slidesPerView: 2,
            },
            720: {
                centeredSlides: false,
                slidesPerView: 3,
            },
            980: {
                centeredSlides: false,
                slidesPerView: 4,
            },
            1300: {
                centeredSlides: false,
                slidesPerView: 5,
            }
        };
    }

    if (isMiniContainer) {
        virtualCondition = false;
        breakpoints = {
            1: {
                slidesPerView: 'auto',
            }
        };
        centerInsufficientSlides = false;
        loopCondition = true;
    } else if (swiperContainer.hasAttribute("data-settings-preview")) {
        breakpoints = {
            1: {
                slidesPerView: 'auto',
                centeredSlides: true,
            }
        };
        centerInsufficientSlides = false;
    }

    const swiper = new Swiper(swiperContainer, {
        autoplay: {
            delay: intervalAutoSliding,
        },

        centeredSlides: centeredSlidesCondition,
        preventClicks: false,
        preventClicksPropagation: false,
        direction: 'horizontal',
        loop: loopCondition,
        centerInsufficientSlides: centerInsufficientSlides,
        loopedSlides: 0,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 15,
        breakpoints: breakpoints,
        breakpointsBase: "container",
        virtual: {
            enabled: virtualCondition,
            addSlidesAfter: 3,
            addSlidesBefore: 3,
            slides: (function () {
                if (!virtualCondition) return [];

                var slides = [];
                for (var i = 0; i < reviews.length; i += 1) {
                    let result = createReview(reviews[i], options);

                    for (let j = 0; j <result.length; j +=1) {
                        //check for design-2, divided slides
                        if (typeof result[j] !== typeof undefined) {
                            let slide = result[j].innerHTML;
                            slides.push(slide);
                        }
                    }
                }
                return slides;
            })()
        },
        on: {
            afterInit: function (swiper) {
                if (isMiniContainer) return;
                if (virtualCondition) {
                    swiper.virtual.update();
                }
                setTimeout(() => {
                    addHiddenContent (window.WIDEREVIEW.options, virtualCondition);
                    if (virtualCondition) {
                        changeSliderArrows();
                    }
                }, 500)
            },
            slideChange: function (swiper) {
                if (virtualCondition) {
                    addHiddenContent (window.WIDEREVIEW.options, virtualCondition);
                }
            },
        }
    });

    swiperContainer.addEventListener('mouseenter', function (event) {
        swiper.autoplay.stop();
    });

    swiperContainer.addEventListener('mouseleave', function (event) {
        swiper.autoplay.start();
    });
}

function changeSliderArrows(theHighestChild) {
    const swiperContainer = document.getElementById("widereview-swiper-container");
    const prevArrow = document.querySelector("#widereview-swiper-container .swiper-button-prev");
    const nextArrow = document.querySelector("#widereview-swiper-container .swiper-button-next");

    if (swiperContainer && prevArrow && nextArrow) {
        let height;

        if (theHighestChild) {
            height = theHighestChild
        } else {
            height = swiperContainer.clientHeight;
        }

        prevArrow.style.top = (height / 2 - prevArrow.clientHeight / 2) + "px";
        nextArrow.style.top = (height / 2 - nextArrow.clientHeight / 2) + "px";
    }
}

export function renderCSS(options) {

    if(typeof window.WIDEREVIEW.renderedOptions == typeof undefined){
        window.WIDEREVIEW.renderedOptions = true;
    }else{
        return;
    }
    let styles = '';

    options = options || {};

    styles += `div.widereview {
        background-color: ${options.background_color};
        margin-top: ${options.widereview_container_margin_top}px;
        margin-bottom: ${options.widereview_container_margin_bottom}px;
    }`;

    styles += `.widereview-title {
        font-weight: ${options.title_style.includes('bold') ? 'bold' : 'normal'}!important;
        font-style: ${options.title_style.includes('italic') ? 'italic' : 'normal'}!important;
        color: ${options.title_color}!important;
        margin-top: ${options.title_top_margin}px !important;
        margin-bottom: ${options.title_bottom_margin}px !important;
        font-size: ${options.title_font_size}rem !important;
    }`;

    styles += `.widereview-subtitle {
        font-weight: ${options.subtitle_style.includes('bold') ? 'bold' : 'normal'} !important;
        font-style: ${options.subtitle_style.includes('italic') ? 'italic' : 'normal'} !important;
        color: ${options.subtitle_color} !important;
        margin-top: ${options.subtitle_top_margin}px !important;
        margin-bottom: ${options.subtitle_bottom_margin}px !important;
        font-size: ${options.subtitle_font_size}rem !important;
    }`;

    styles += `.widereview-subtitle-without-reviews {
        font-weight: ${options.subtitle_without_reviews_style.includes('bold') ? 'bold' : 'normal'} !important;
        font-style: ${options.subtitle_without_reviews_style.includes('italic') ? 'italic' : 'normal'} !important;
        color: ${options.subtitle_without_reviews_color} !important;
        margin-top: ${options.subtitle_without_reviews_top_margin}px !important;
        margin-bottom: ${options.subtitle_without_reviews_bottom_margin}px !important;
        font-size: ${options.subtitle_without_reviews_font_size}rem !important;
    }`;

    styles += `.widereview-add_review {
        border-color: ${options.add_button_border_color} !important;
        background-color: ${options.add_button_background_color} !important;
        color: ${options.add_button_color} !important;
    }`;

    styles += `.widereview-add_review:focus,
               .widereview-add_review:active {
        border: 1px solid ${options.add_button_border_color} !important;
        background-color: ${options.add_button_background_color} !important;
        color: ${options.add_button_color} !important;
    }`;

    styles += `.widereview-reviewItem {
        background-color: ${options.review_background_color};
    }`;

    styles += `.widereview-reviewItem-name {
        font-weight: ${options.name_style.includes('bold') ? 'bold' : 'normal'} !important;
        font-style: ${options.name_style.includes('italic') ? 'italic' : 'normal'} !important;
        color: ${options.name_color} !important;
    }`;

    styles += `.widereview-reviewItem-review {
        font-weight: ${options.review_style.includes('bold') ? 'bold' : 'normal'} !important;
        font-style: ${options.review_style.includes('italic') ? 'italic' : 'normal'} !important;
        color: ${options.review_color} !important;
    }`;

    styles += `.widereview-reviewItem-verified {
        background-color: ${options.verified_background_color} !important;
        color: ${options.verified_color} !important;
    }`;

    styles += `.widereview-btn-submit {
        background-color: ${options.form_submit_background_color} !important;
        border-color: ${options.form_submit_border_color} !important;
        color: ${options.form_submit_color} !important;
    }`;

    styles += `.widereview-btn-reset {
        background-color: ${options.form_reset_background_color} !important;
        border-color: ${options.form_reset_border_color} !important;
        color: ${options.form_reset_color} !important;
    }`;

    styles += `.widereview-star svg {
        fill: ${options.rate_color_default};
    }`;

    styles += `.widereview-star.selected svg {
        fill: ${options.rate_color_selected};
    }`;

    styles += `.widereview-star.half-filled svg {
        fill: ${options.rate_color_selected};
    }`;

    styles += `.widereview-star.half-filled svg .under {
        fill: ${options.rate_color_default};
    }`;

    styles += `.widereview-success-icon svg {
        fill: ${options.success_icon_color};
    }`;

    styles += `.widereview-success-button .widereview-btn {
        background-color: ${options.success_button_background_color};
        border-color: ${options.success_button_border_color};
        color: ${options.success_button_color} !important;
    }`;

    styles += `.swiper-container .wr-swiper-button-prev,
               .swiper-container .wr-swiper-button-next {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        display: flex !important;
    }`;

    styles += `.wr-swiper-button-prev::after,
               .wr-swiper-button-next::after {
        border: solid ${options.slider_arrow_color};
        border-width: 0 3px 3px 0;
    }`;

    styles += `.swiper-button--dark-theme {
        background-color: ${options.slider_arrow_color};
    }`;

    styles += `.widereview-btn-more-text {
        background-color: ${options.add_button_more_background_color};
        border-color: ${options.add_button_more_border_color};
        color: ${options.add_button_more_color};
    }`;

    styles += `.widereview-btn-more-text:focus,
               .widereview-btn-more-text:active {
        background-color: ${options.add_button_more_background_color};
        border: 1px solid ${options.add_button_more_border_color};
        color: ${options.add_button_more_color};
    }`;

    styles += options.custom_css;


    const style = document.getElementById('widereview-style') || (function () {
        const style = document.createElement('style');
        style.id = 'widereview-style';
        style.type = 'text/css';

        document.getElementsByTagName('head')[0].appendChild(style);

        return style;
    })();

    style.innerHTML = styles;
}

export function renderElementsPackContainer(container, reviews, options) {
    if (!container || !reviews || !options) return;

    removeAttributeStyle(container);

    container.innerHTML = '';

    const widereview = document.createElement('div');
    widereview.className = "widereview";
    container.append(widereview);

    const widereviewHeader = document.createElement('div');
    widereviewHeader.className = "widereview-header";
    widereview.append(widereviewHeader);

    const widereviewScrolling = document.createElement('div');
    widereviewScrolling.className = "visually-hidden";
    widereviewScrolling.classList.add('widereview-scroll-anchor');
    widereviewScrolling.setAttribute('id', 'widereview-grid-scroll');
    widereviewHeader.append(widereviewScrolling);

    const widereviewHeaderTitles = document.createElement('div');
    widereviewHeaderTitles.classList.add("widereview-header-titles", "widereview-header-titles--pack");
    widereviewHeader.append(widereviewHeaderTitles);

    if (reviews.length < 1) {
        widereview.classList.add('widereview--no-review');

        const widereviewSubTitle = document.createElement('p');
        widereviewSubTitle.className = "widereview-subtitle-without-reviews";
        widereviewSubTitle.innerHTML = options.subtitle_without_reviews;
        widereviewHeaderTitles.append(widereviewSubTitle);
    }

    if (reviews.length) {
        // Header

        const widereviewTitle = document.createElement('h2');
        widereviewTitle.className = "widereview-title";
        widereviewTitle.innerHTML = options.title;
        widereviewHeaderTitles.append(widereviewTitle);

        const widereviewSubTitle = document.createElement('p');
        widereviewSubTitle.className = "widereview-subtitle";
        widereviewSubTitle.innerHTML = options.subtitle;
        widereviewHeaderTitles.append(widereviewSubTitle);


        if (options.add_button_enabled) {
            const widereviewHeaderActions = document.createElement('div');
            widereviewHeaderActions.className = "widereview-header-actions";
            widereviewHeader.append(widereviewHeaderActions);

            const widereviewAddButton = document.createElement('button');
            widereviewAddButton.className = "widereview-btn widereview-add_review";
            widereviewAddButton.setAttribute('type', 'button');
            widereviewAddButton.innerHTML = options.add_button_text;
            if (container.getAttribute('id') !== 'settingsPreview') {
                widereviewAddButton.setAttribute('data-micromodal-trigger', 'widereview-modal');
            }
            widereviewHeaderActions.append(widereviewAddButton);
        }


        // Reviews

        const widereviewContent = document.createElement('div');
        widereviewContent.className = "widereview-content";
        widereviewContent.classList.add('widereview-content--pack');
        widereview.append(widereviewContent);

        for (let i = 0; i < reviews.length; i++) {
            const review = reviews[i];

            const reviewPackWrapper = document.createElement('div');
            reviewPackWrapper.className = 'widereview-pack-review-wrapper';
            reviewPackWrapper.setAttribute('widereview-pack-review-id', i + 1);
            widereviewContent.append(reviewPackWrapper);
            if (options.enable_grid_mobile_dividing === true) {
                const styleElement = document.createElement("style");
                styleElement.textContent =
                    `@media (max-width: 500px) {
                        .widereview-pack-review-wrapper {
                            width: calc((100% - 12%) / 2 );
                        }
                    }`;
                reviewPackWrapper.insertAdjacentElement("beforeend", styleElement);
            }


            const reviewItem = document.createElement('div');
            reviewItem.className = "widereview-reviewItem";
            reviewPackWrapper.append(reviewItem);
            reviewItem.classList.add('widereview-reviewItem--pack');


            if (review.file) {
                const thumbnail = document.createElement('div');
                thumbnail.className = "widereview-thumbnail";
                reviewItem.append(thumbnail);

                if (review.file_type === 'image') {
                    if (review.file_height < 1 || review.file_width < 1) return;

                    const reviewItemImage = document.createElement('img');
                    reviewItemImage.src = review.file;

                    if (review.lazy === true) {
                        reviewItemImage.setAttribute("loading", "lazy");
                    }

                    let WIDTH = 232;

                    if (window.innerWidth > 320) {
                        if (options.carousel_design === '2') {
                            WIDTH = 250;
                        }
                    } else {
                        if (options.carousel_design === '2') {
                            WIDTH = 264;
                        } else {
                            WIDTH = 250;
                        }
                    }
                    reviewItemImage.width = WIDTH ;
                    reviewItemImage.height =  review.file_height / review.file_width * WIDTH;
                    reviewItemImage.setAttribute('original-width', review.file_width);
                    reviewItemImage.setAttribute('original-height', review.file_height);

                    thumbnail.append(reviewItemImage);

                } else if (review.file_type === 'video') {
                    if (review.file_height < 1 || review.file_width < 1) return;

                    const reviewItemVideo = document.createElement('video');

                    let WIDTH = 232;

                    if (options.carousel_design === '2') {
                        WIDTH = 250;
                    }

                    reviewItemVideo.width = WIDTH ;
                    reviewItemVideo.height =  review.file_height / review.file_width * WIDTH;

                    reviewItemVideo.controls = true;
                    reviewItemVideo.loop = true;
                    reviewItemVideo.muted = true;
                    reviewItemVideo.playsinline = 'inline';
                    // reviewItemVideo.setAttribute('preload', 'metadata');
                    reviewItemVideo.setAttribute('playsinline', '');
                    reviewItemVideo.src = review.file + '#t=0.001';
                    thumbnail.append(reviewItemVideo);
                } else {
                    thumbnail.remove();
                }

            }

            const reviewItemContent = document.createElement('div');
            reviewItemContent.className = "widereview-reviewItem-content";
            reviewItem.append(reviewItemContent);

            //use styles of the second carousel-designs
            if (options.carousel_design === '2') {
                reviewItem.classList.add("widereview-reviewItem--design2");
                reviewItemContent.classList.add("widereview-reviewItem-content--design2");
            }

            if (options.name_show != "hide_all") {
                const reviewItemName = document.createElement('div');
                reviewItemName.className = "widereview-reviewItem-name";
                reviewItemName.innerHTML = review.name;
                reviewItemContent.append(reviewItemName);
            }

            if (options.rate_enabled && review.rate) {
                const rate = parseInt(review.rate);

                const reviewItemRate = document.createElement('div');
                reviewItemRate.className = "widereview-reviewItem-rate";
                reviewItemRate.innerHTML = renderRate(rate);
                reviewItemContent.append(reviewItemRate);
            }

            const reviewItemReview = document.createElement('div');
            reviewItemReview.className = "widereview-reviewItem-review";
            reviewItemReview.innerHTML = nl2br(review.text);
            reviewItemContent.append(reviewItemReview);

            if (review.verified) {
                const reviewItemVerified = document.createElement('div');
                reviewItemVerified.className = "widereview-btn widereview-btn-sm widereview-reviewItem-verified";
                reviewItemVerified.innerHTML = options.verified;
                reviewItemContent.append(reviewItemVerified);
            }
        }
    }

    window.addEventListener('resize', function (evt) {
        adaptPackImg(container);
    })
};

export function renderElements(container, reviews, options) {
    if (!container || !reviews || !options) return;

    removeAttributeStyle(container);

    container.innerHTML = '';

    const widereview = document.createElement('div');
    widereview.className = "widereview";
    container.append(widereview);

    if (reviews.length < 1) {
        widereview.classList.add('widereview--no-review');
    }

    // Header
    const widereviewHeader = document.createElement('div');
    widereviewHeader.className = "widereview-header";
    widereview.append(widereviewHeader);

    const widereviewScrolling = document.createElement('div');
    widereviewScrolling.className = "visually-hidden";
    widereviewScrolling.classList.add('widereview-scroll-anchor');
    widereviewScrolling.setAttribute('id', 'widereview-scroll');
    widereviewHeader.append(widereviewScrolling);

    const widereviewHeaderTitles = document.createElement('div');
    widereviewHeaderTitles.className = "widereview-header-titles";
    widereviewHeader.append(widereviewHeaderTitles);

    if (reviews.length) {
        const widereviewTitle = document.createElement('h2');
        widereviewTitle.className = "widereview-title";
        widereviewTitle.innerHTML = options.title;
        widereviewHeaderTitles.append(widereviewTitle);

        const widereviewSubTitle = document.createElement('p');
        widereviewSubTitle.className = "widereview-subtitle";
        widereviewSubTitle.innerHTML = options.subtitle;
        widereviewHeaderTitles.append(widereviewSubTitle);
    } else{
        const widereviewSubTitle = document.createElement('p');
        widereviewSubTitle.className = "widereview-subtitle-without-reviews";
        widereviewSubTitle.innerHTML = options.subtitle_without_reviews;
        widereviewHeaderTitles.append(widereviewSubTitle);
    }

    if (options.add_button_enabled) {
        const widereviewHeaderActions = document.createElement('div');
        widereviewHeaderActions.className = "widereview-header-actions";
        widereviewHeader.append(widereviewHeaderActions);

        const widereviewAddButton = document.createElement('button');
        widereviewAddButton.className = "widereview-btn widereview-add_review";
        widereviewAddButton.setAttribute('type', 'button');
        widereviewAddButton.innerHTML = options.add_button_text;
        if (container.getAttribute('id') !== 'settingsPreview') {
            widereviewAddButton.setAttribute('data-micromodal-trigger', 'widereview-modal');
        }
        widereviewHeaderActions.append(widereviewAddButton);
    }


    // Content

    if (reviews.length) {

        const widereviewContent = document.createElement('div');
        widereviewContent.className = "widereview-content";
        widereview.append(widereviewContent);

        const swiperContainer = document.createElement('div');
        swiperContainer.id = "widereview-swiper-container";
        widereviewContent.append(swiperContainer);
        swiperContainer.className = "swiper-container";

        const swiperWrapper = document.createElement('div');
        swiperWrapper.className = "swiper-wrapper";
        swiperContainer.append(swiperWrapper);

        const swiperPrev = document.createElement('div');
        swiperPrev.className = "swiper-button-prev";
        swiperPrev.classList.add("wr-swiper-button-prev");
        if (options.arrow_design === '2') {
            swiperPrev.classList.add("swiper-button--dark-theme", "swiper-button-prev--dark-theme");
        } else {
            swiperPrev.classList.remove("swiper-button--dark-theme", "swiper-button-prev--dark-theme");
        }
        swiperContainer.append(swiperPrev);

        const swiperNext = document.createElement('div');
        swiperNext.className = "swiper-button-next";
        swiperNext.classList.add("wr-swiper-button-next");
        if (options.arrow_design === '2') {
            swiperNext.classList.add("swiper-button--dark-theme", "swiper-button-next--dark-theme");
        } else {
            swiperNext.classList.remove("swiper-button--dark-theme", "swiper-button-next--dark-theme");
        }
        swiperContainer.append(swiperNext);

        // Reviews

        if (reviews.length < 30) {
            for (let i = 0; i < reviews.length; i++) {
                let result = createReview(reviews[i], options);

                for (let j = 0; j <result.length; j +=1) {
                    //check for design-2, divided slides
                    if (typeof result[j] !== typeof undefined) {
                        let slide = result[j];
                        swiperWrapper.append(slide);
                    }
                }
            }
        }
    }

}

function createReview(review, options) {
    let slideUnited;
    let slideDivided;
    slideUnited = document.createElement('div');
    slideUnited.className = "swiper-slide";

    const reviewItem = document.createElement('div');
    reviewItem.className = "widereview-reviewItem";
    slideUnited.append(reviewItem);

    if (review.file) {
        const thumbnail = document.createElement('div');
        thumbnail.className = "widereview-thumbnail";

        //verify to divide slide into two parts

        if (options.carousel_design === '2') {
            slideDivided = document.createElement('div');
            slideDivided.className = "swiper-slide";
            // swiperWrapper.append(swiperSlide);

            const reviewItem = document.createElement('div');
            reviewItem.className = "widereview-reviewItem";
            reviewItem.classList.add("widereview-reviewItem--remove-shadow");
            reviewItem.classList.add("widereview-reviewItem--design2");
            slideDivided.append(reviewItem);
            reviewItem.append(thumbnail);
        } else {
            reviewItem.append(thumbnail);
        }

        if (review.file_type === 'image') {
            if (review.file_height < 1 || review.file_width < 1) return;

            const reviewItemImage = document.createElement('img');
            reviewItemImage.src = review.file;

            if (review.lazy === true) {
                reviewItemImage.setAttribute("loading", "lazy");
            }

            let WIDTH = 310;

            if (window.innerWidth > 768) {
                if (options.carousel_design === '2') {
                    WIDTH = 350;
                }
            } else {
                if (options.carousel_design === '2') {
                    WIDTH = 200;
                } else {
                    WIDTH = 180
                }
            }

            reviewItemImage.width = WIDTH ;
            reviewItemImage.height =  review.file_height / review.file_width * WIDTH;

            if (options.carousel_design === '2') {
                reviewItemImage.setAttribute('mobile_width', review.size.design_2_mobile.width);
                reviewItemImage.setAttribute('mobile_height', review.size.design_2_mobile.height);
                reviewItemImage.setAttribute('desktop_width', review.size.design_2_desktop.width);
                reviewItemImage.setAttribute('desktop_height', review.size.design_2_desktop.height);
            } else {
                reviewItemImage.setAttribute('mobile_width', review.size.design_1_mobile.width);
                reviewItemImage.setAttribute('mobile_height', review.size.design_1_mobile.height);
                reviewItemImage.setAttribute('desktop_width', review.size.design_1_desktop.width);
                reviewItemImage.setAttribute('desktop_height', review.size.design_1_desktop.height);
            }


            thumbnail.append(reviewItemImage);

        } else if (review.file_type === 'video') {
            if (review.file_height < 1 || review.file_width < 1) return;

            const reviewItemVideo = document.createElement('video');

            let WIDTH = 310;

            if (window.innerWidth > 768) {
                if (options.carousel_design === '2') {
                    WIDTH = 350;
                }
            } else {
                if (options.carousel_design === '2') {
                    WIDTH = 200;
                } else {
                    WIDTH = 180
                }
            }

            reviewItemVideo.width = WIDTH ;
            reviewItemVideo.height =  review.file_height / review.file_width * WIDTH;

            reviewItemVideo.controls = true;
            reviewItemVideo.loop = true;
            reviewItemVideo.muted = true;
            reviewItemVideo.playsinline = 'inline';
            reviewItemVideo.setAttribute('playsinline', '');
            thumbnail.append(reviewItemVideo);

            const supportVideoResolutions = ['avi','mov','mp4','webm'];

            supportVideoResolutions.forEach(function (resolution) {
                let reviewItemVideoSource = document.createElement('source');
                reviewItemVideoSource.src = review.file + '#t=0.001';
                reviewItemVideoSource.setAttribute('type', 'video/' + resolution + '');
                reviewItemVideo.append(reviewItemVideoSource);
            })
        } else {
            thumbnail.remove();
        }

    }

    const reviewItemContent = document.createElement('div');
    reviewItemContent.className = "widereview-reviewItem-content";
    reviewItem.append(reviewItemContent);

    //use styles of the second carousel-designs
    if (options.carousel_design === '2') {
        reviewItem.classList.add("widereview-reviewItem--design2");
        reviewItemContent.classList.add("widereview-reviewItem-content--design2");
    }

    if (options.name_show != "hide_all") {
        const reviewItemName = document.createElement('div');
        reviewItemName.className = "widereview-reviewItem-name";
        reviewItemName.innerHTML = review.name;
        reviewItemContent.append(reviewItemName);
    }

    if (options.rate_enabled && review.rate) {
        const rate = parseInt(review.rate);

        const reviewItemRate = document.createElement('div');
        reviewItemRate.className = "widereview-reviewItem-rate";
        reviewItemRate.innerHTML = renderRate(rate);
        reviewItemContent.append(reviewItemRate);
    }

    const reviewItemReview = document.createElement('div');
    reviewItemReview.className = "widereview-reviewItem-review";
    reviewItemReview.innerHTML = nl2br(review.text);
    reviewItemContent.append(reviewItemReview);

    if (review.verified) {
        const reviewItemVerified = document.createElement('div');
        reviewItemVerified.className = "widereview-btn widereview-btn-sm widereview-reviewItem-verified";
        reviewItemVerified.innerHTML = options.verified;
        reviewItemContent.append(reviewItemVerified);
    }

    return [slideUnited, slideDivided];
}

export function renderElementsMiniContainer(container, reviews, options) {
    if (!container || !reviews || !options) return;

    removeAttributeStyle(container);

    container.innerHTML = '';

    const widereview = document.createElement('div');
    widereview.className = "widereview";

    // Content

    if (reviews.length) {

        const widereviewContent = document.createElement('div');
        widereviewContent.className = "widereview-content";

        const swiperContainer = document.createElement('div');

        swiperContainer.id = "widereview-swiper-containerSmallProductPage";
        container.append(swiperContainer);


        swiperContainer.className = "swiper-container";

        const swiperWrapper = document.createElement('div');
        swiperWrapper.className = "swiper-wrapper";
        swiperContainer.append(swiperWrapper);

        const swiperPrev = document.createElement('div');
        swiperPrev.className = "swiper-button-prev";
        swiperPrev.classList.add("wr-swiper-button-prev");
        if (options.arrow_design === '2') {
            swiperPrev.classList.add("swiper-button--dark-theme", "swiper-button-prev--dark-theme");
        } else {
            swiperPrev.classList.remove("swiper-button--dark-theme", "swiper-button-prev--dark-theme");
        }
        swiperContainer.append(swiperPrev);

        const swiperNext = document.createElement('div');
        swiperNext.className = "swiper-button-next";
        swiperNext.classList.add("wr-swiper-button-next");
        if (options.arrow_design === '2') {
            swiperNext.classList.add("swiper-button--dark-theme", "swiper-button-next--dark-theme");
        } else {
            swiperNext.classList.remove("swiper-button--dark-theme", "swiper-button-next--dark-theme");
        }
        swiperContainer.append(swiperNext);

        // Reviews

        for (let i = 0; i < reviews.length; i++) {
            const review = reviews[i];

            const swiperSlide = document.createElement('div');
            swiperSlide.className = "swiper-slide";
            swiperWrapper.append(swiperSlide);

            const reviewItem = document.createElement('div');
            reviewItem.className = "widereview-reviewItem";
            swiperSlide.append(reviewItem);

            if (review.file && review.file_type === 'image') {
                if (review.file_height < 1 || review.file_width < 1) return;

                const thumbnail = document.createElement('div');
                thumbnail.className = "widereview-thumbnail";
                reviewItem.append(thumbnail);

                const reviewItemImage = document.createElement('img');
                reviewItemImage.src = review.file;

                if (review.lazy === true) {
                    reviewItemImage.setAttribute("loading", "lazy");
                }

                thumbnail.append(reviewItemImage);
            }

            if (options.name_show != "hide_all") {
                const reviewItemName = document.createElement('div');
                reviewItemName.className = "widereview-reviewItem-name";
                reviewItemName.innerHTML = review.name;
                reviewItem.append(reviewItemName);
            }

            if (options.rate_enabled && review.rate) {
                const rate = parseInt(review.rate);

                const reviewItemRate = document.createElement('div');
                reviewItemRate.className = "widereview-reviewItem-rate";
                reviewItemRate.innerHTML = renderRate(rate);
                reviewItem.append(reviewItemRate);
            }

            const reviewItemReview = document.createElement('div');
            reviewItemReview.className = "widereview-reviewItem-review";
            reviewItemReview.classList.add('widereview-reviewItem-review--scroll');
            reviewItemReview.innerHTML = nl2br(review.text);
            reviewItem.append(reviewItemReview);

            if (review.verified) {
                const reviewItemVerifiedContainer = document.createElement('div');
                reviewItemVerifiedContainer.className = "widereview-reviewItem-verified__wrapper";
                reviewItem.append(reviewItemVerifiedContainer);

                const reviewItemVerified = document.createElement('span');
                reviewItemVerified.className = "widereview-btn widereview-btn-sm widereview-reviewItem-verified";
                reviewItemVerified.innerHTML = options.verified;
                reviewItemVerifiedContainer.append(reviewItemVerified);
            }
        }
    }
}

export function renderForm(container, options, settings = {}) {
    if (!container || !options) return;

    let hash = window.location.hash.replaceAll("%23","#").split('#');

    if (hash[1] === 'widereview-show-review-form' && hash.length>2) {
        window.WIDEREVIEW.url_get_form = window.WIDEREVIEW.url_get_form + '&order_id=' + hash[2];
    }

    const modal = '' +
        '<div class="widereview-modal widereview-modal--slide" id="widereview-modal" aria-hidden="true">' +
        '<div class="widereview-modal-container" tabindex="-1" data-micromodal-close>' +
        '<div class="widereview-modal-dialog" role="dialog" aria-modal="true">' +
        '<button class="widereview-modal-close" aria-label="Close modal" data-micromodal-close></button>' +
        '<div class="widereview-modal-content">' +
        '<iframe class="widereview-iframe" id="widereview-iframe" src="' + renderIframeUrl(window.WIDEREVIEW.url_get_form, getCookie()) + '" style="border: none"></iframe>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';

    const modalSuccess = '' +
        '<div class="widereview-modal widereview-modal--slide" id="widereview-success" aria-hidden="true">' +
        '<div class="widereview-modal-container" tabindex="-1" data-micromodal-close>' +
        '<div class="widereview-modal-dialog" role="dialog" aria-modal="true">' +
        '<div class="widereview-modal-content">' +
        '<p class="widereview-success-icon"><svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-14c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm-1 9a.997.997 0 01-.707-.293l-2-2a1 1 0 111.414-1.414L9 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4A.996.996 0 019 13z"/></svg></p>' +
        '<p class="widereview-success-title">' + options.success_text + '</p>' +
        '<p class="widereview-success-button"><button class="widereview-btn widereview-btn-lg" type="submit" data-micromodal-close>' + options.success_button_text + '</button></p>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';

    document.body.insertAdjacentHTML('beforeend',  modal + modalSuccess);
    const iframe = document.getElementById('widereview-iframe');
    const iframeContent = iframe && iframe.contentWindow ? iframe.contentWindow : null;

    MicroModal.init({
        onShow: (modal) => {
            if (modal.id === 'widereview-modal') {
            }
        },
        onClose: (modal) => {
            if (modal.id === 'widereview-modal') {
                iframeContent.postMessage({
                    status: 'widereview.resetForm',
                }, settings.url_app);
            }
        },
    });

    window.addEventListener("message", (event) => {
        if (event.origin !== settings.url_app)
            return;

        const response = event.data;

        if (response.status === 'widereview.close') {
            MicroModal.close('widereview-modal');
        } else if (response.status === 'error') {
        } else if (response.status === 'success') {
            setCookie(response.cookie);


            MicroModal.close('widereview-modal');
            MicroModal.show('widereview-success', {});

            if(response.response.discount_code){
                let message = document.querySelector('.widereview-success-title');
                message.innerHTML = '';
                const text = document.createElement('p');
                text.className = "widereview-success-title__text";
                text.innerHTML = response.response.discount_text;
                message.append(text);

                const discountCode = document.createElement('p');
                discountCode.className = "widereview-success-title__code";
                discountCode.innerHTML = response.response.discount_code;
                message.append(discountCode);
            }

            iframe.src = renderIframeUrl(window.WIDEREVIEW.url_get_form, response.cookie && response.cookie.value ? response.cookie.value : '');
        }
    }, false);


    if (window.location.hash) {
        let hash = window.location.hash.replaceAll("%23","#").split('#');
        let url = window.location.href.split('#')[0];

        if (hash[1] === 'widereview-show-review-form') {
            MicroModal.show('widereview-modal');
            history.pushState(null, null, url);
        }

        if (hash[1] === 'widereview-unsubscribe' && hash.length>3) {
            // #label#email#order_id
            let scripts = document.getElementsByTagName('script');

            let unsubscribeLink, ind, url;
            for(ind in scripts){
                if(scripts[ind].src != undefined && scripts[ind].src.indexOf('js/widereview.js')>0){

                    url = new URL(scripts[ind].src);

                    unsubscribeLink = url.protocol + '//' + url.host + '/api/get_subscible_status?email='+hash[2]+'&order_id='+hash[3]+'&shop='+Shopify.shop;

                }
            }

            window.originalFetch(unsubscribeLink + '&unsubscribe=true')
                .then(response => response.json())
                .then (function (data) {
                    renderUnsubscribe(data);

                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
}

function renderUnsubscribe(data) {
    let modal = document.getElementById('widereview-unsubscribe');
    if(modal!=null){
        modal.remove();
    }
    let modalUnsubscribe = '' +
        '<div class="widereview-modal widereview-modal--slide" id="widereview-unsubscribe" aria-hidden="true">' +
        '<div class="widereview-modal-container" tabindex="-1" data-micromodal-close>' +
        '<div class="widereview-modal-dialog" role="dialog" aria-modal="true">' +
        '<div class="widereview-modal-content">' +
        '<p class="widereview-success-icon"><svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-14c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm-1 9a.997.997 0 01-.707-.293l-2-2a1 1 0 111.414-1.414L9 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4A.996.996 0 019 13z"/></svg></p>' +
        '<p class="widereview-success-title">' + data.messages.text + '</p>' +
        '<p class="widereview-success-link" id="widereview-unsubscribe-link" data-status="' + data.unsubscribe + '">' + data.messages.link + '</p>' +
        '<p class="widereview-success-button"><button class="widereview-btn widereview-btn-lg" type="button" data-micromodal-close>' + data.messages.close + '</button></p>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';
    document.body.insertAdjacentHTML('beforeend',  modalUnsubscribe);
    MicroModal.show('widereview-unsubscribe', {});

    let unsubscribeElem = document.getElementById('widereview-unsubscribe-link');

    unsubscribeElem.addEventListener('click', function(event) {
        event.preventDefault();

        let scripts = document.getElementsByTagName('script');
        let hash = window.location.hash.replaceAll("%23","#").split('#');
        let unsubscribeLink, ind, url;

        for(ind in scripts){
            if(scripts[ind].src != undefined && scripts[ind].src.indexOf('js/widereview.js')>0){

                url = new URL(scripts[ind].src);

                unsubscribeLink = url.protocol + '//' + url.host + '/api/get_subscible_status?email='+hash[2]+'&order_id='+hash[3]+'&shop='+Shopify.shop;

            }
        }

        window.originalFetch(unsubscribeLink + '&unsubscribe=' + unsubscribeElem.getAttribute('data-status'))
            .then(response => response.json())
            .then (function (data) {
                renderUnsubscribe(data);

            })
            .catch(function (error) {
                console.log(error);
            });
    });
}

export function renderFormPreview(container, options, settings = {}) {
    if (!container || !options) return;

    const modal = '' +
        '<div class="widereview-modal widereview-modal--slide" id="widereview-modal" aria-hidden="true">' +
        '<div class="widereview-modal-container" tabindex="-1" data-micromodal-close>' +
        '<div class="widereview-modal-dialog" role="dialog" aria-modal="true">' +
        '<button class="widereview-modal-close" aria-label="Close modal" data-micromodal-close></button>' +
        '<div class="widereview-modal-content">' + (`
    <input tabindex="-1" type="hidden" name="product_id" value="" required/>
    <input tabindex="-1" type="hidden" name="shop" value="" required/>
    <div class="widereview-stack widereview-stack--vertical">
        <div class="widereview-stack-item">
            <h6 class="widereview-form-title">${options.form_title_text}</h6>
            <p class="widereview-form-subtitle">${options.form_subtitle_text}</p>
        </div>
        <div class="widereview-stack-item">
            <label class="widereview-form-label">${options.form_name_label}</label>
            <div class="widereview-form-row">
                <input class="widereview-form-input" tabindex="-1" type="text" name="name" value="" required minlength=""/>
                <div class="widereview-form-error">Please enter a valid name (min length: 2)</div>
            </div>
        </div>
        <div class="widereview-stack-item">
            <label class="widereview-form-label">${options.form_review_label}</label>
            <div class="widereview-form-row">
                <textarea class="widereview-form-input" tabindex="-1" rows="4" type="text" name="text" required minlength=""></textarea>
                <div class="widereview-form-error">Please enter a valid review (min length: 16)</div>
            </div>
        </div>
        <div class="widereview-stack-item">
            <label class="widereview-form-label">${options.form_file_label} <small>(Max file size: 20 Mb)</small></label>
            <div class="widereview-form-file">
                <label class="widereview-form-file-label" id="widereview-file-preview" for="widereview-file-input"></label>
                <input class="widereview-form-file-input" tabindex="-1" id="widereview-file-input" type="file" name="file" value="">
                <button class="widereview-form-file-reset" id="widereview-file-reset" type="button"></button>
            </div>
        </div>
        <div class="widereview-stack-item">
            <div class="widereview-stack">
                <div class="widereview-stack-item">
                    <button class="widereview-btn widereview-btn-submit" id="widereview-submit" tabindex="-1" type="submit">${options.form_submit_text}</button>
                </div>
                <div class="widereview-stack-item">
                    <button class="widereview-btn widereview-btn-reset" id="widereview-reset" type="reset" data-micromodal-close>${options.form_reset_text}</button>
                </div>
            </div>
        </div>
    </div>
        `) +
        '</div>' +
        '</div>' +
        '</div>';

    container.innerHTML += modal;

    const modalSuccess = '' +
        '<div class="widereview-modal widereview-modal--slide" id="widereview-success" aria-hidden="true">' +
        '<div class="widereview-modal-container" tabindex="-1" data-micromodal-close>' +
        '<div class="widereview-modal-dialog" role="dialog" aria-modal="true">' +
        '<div class="widereview-modal-content">' +
        '<p class="widereview-success-icon"><svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-14c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm-1 9a.997.997 0 01-.707-.293l-2-2a1 1 0 111.414-1.414L9 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4A.996.996 0 019 13z"/></svg></p>' +
        '<p class="widereview-success-title">' + options.success_text + '</p>' +
        '<p class="widereview-success-button"><button class="widereview-btn widereview-btn-lg" type="submit" data-micromodal-close>' + options.success_button_text + '</button></p>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';

    container.innerHTML += modalSuccess;

    MicroModal.init({});
}

function renderRate(rate) {
    rate = (Math.round(rate*2)/2);

    let result = '';
    let count = rate;

    for (let i = 1; i <= 5; i++) {
        if (i <= rate && count >= 1) {
            result += '<span class="widereview-star selected">' +
                '<svg viewBox="0 0 52.916667 52.916667">' +
                '<g transform="translate(0,-270.54165)">' +
                '<path d="m 24.790494,270.53466 6.425597,17.29833 18.237351,0.18898 -14.552083,11.71727 5.197173,17.48139 L 24.790494,306.73179 9.4824609,317.22063 14.585139,299.55025 0.03305582,288.11647 18.55389,287.644 Z"/>' +
                '</g>' +
                '</svg>' +
                '</span>';
            count --;
        } else if (i > rate && (count < 1 && count > 0)){
            result += '<span class="widereview-star half-filled">' +
                '<svg viewBox="0 0 52.916667 52.916667">' +
                '<g transform="translate(0,-270.54165)">' +
                '<path class="under" d="m 24.739893,270.60149 6.52009,17.10933 18.23735,0.37798 -14.55208,11.33928 5.10268,17.85938 -15.30804,-10.29985 z"/>' +
                '<path d="M 24.739893,270.60149 18.219803,287.71082 -0.01754791,288.0888 14.534535,299.42808 9.4318551,317.28746 24.739893,306.98761 Z"/>' +
                '</g>' +
                '</svg>' +
                '</span>';
            count --;
        } else  {
            result += '<span class="widereview-star">' +
                '<svg viewBox="0 0 52.916667 52.916667">' +
                '<g transform="translate(0,-270.54165)">' +
                '<path d="m 24.790494,270.53466 6.425597,17.29833 18.237351,0.18898 -14.552083,11.71727 5.197173,17.48139 L 24.790494,306.73179 9.4824609,317.22063 14.585139,299.55025 0.03305582,288.11647 18.55389,287.644 Z"/>' +
                '</g>' +
                '</svg>' +
                '</span>';
        }
    }

    return '<div class="widereview-stars">' + result + '</div>';
}

export function getCookie() {
    const cookie = document.cookie
        .split('; ')
        .filter(row => row.indexOf(COOKIE_NAME) === 0)[0];

    return cookie
        ? decodeURIComponent(cookie.split('=')[1])
        : '';
}

export function setCookie(data) {
    if (data) {
        document.cookie = `${COOKIE_NAME}=${data.value}; expires=${(new Date(data.expires)).toUTCString()}; path=/`;
    }
}

function renderIframeUrl(url, queryString = '') {
    if (url) {
        let shop = '';

        if (window.Shopify && window.Shopify.shop) {
            shop = Shopify.shop;
        } else {
            shop = window.location.hostname;
        }

        if (shop.indexOf('myshopify') === -1) {
            throw new Error('widereview app did not find correct shop name');
        }

        return url + (url.indexOf('?') === -1 ? '?' : '&') + [
            'cookie=' + queryString,
            'shop=' + shop,
        ].join('&');
    }

    return 'about:blank';
}

export function implantRate(data) {

    let rateList = document.querySelectorAll('.widereview-rate');

    rateList = checkIfManualRate (rateList);
    rateList.forEach(function (elem) {
        if (elem.hasAttribute('widereview-rate-rendered')) return;

        removeAttributeStyle(elem);

        if (elem.hasAttribute('data-widereview-rate')) {
            fillRateContainer(elem, elem.getAttribute('data-widereview-rate'), elem.getAttribute('data-widereview-amount'));
        } else if (elem.hasAttribute('product-id')) {
            fillRateContainer(elem, data.render.Rate[elem.getAttribute('product-id')]['rate'], data.render.Rate[elem.getAttribute('product-id')]['countReviews']);
        } else if ( typeof meta != "undefined" && typeof meta.product != "undefined" && typeof meta.product.id != "undefined") {
            fillRateContainer(elem, data.render.Rate[meta.product.id]['rate'], data.render.Rate[meta.product.id]['countReviews']);
        }

        let additionalClass = addClassForRateCentering (data.options, elem);

        if (additionalClass !== '') {
            elem.classList.add(additionalClass);
        }
    });

    function fillRateContainer (parent, rate, countReviews) {
        parent.setAttribute('widereview-rate-rendered', 'true');

        if (countReviews <= 0) return;
        if (rate > 5) {
            rate = 5;
        } else if (rate <=0) {
            rate = 0
        }

        let newElement;

        if (parent.closest('.card__information')) {
            newElement = document.createElement("div");
        } else {
            newElement = document.createElement("a");
            if (data.options.enabled_product_page && document.querySelector('#widereview-liquid')){
                newElement.setAttribute('href', '#widereview-scroll');
            } else if(data.options.enabled_grid_pack) {
                newElement.setAttribute('href', '#widereview-grid-scroll');
            } else {
                newElement.setAttribute('href', '#');
            }

        }

        newElement.innerHTML = renderRate(rate);
        newElement.classList.add('widereview-implantedStars-container');


        if(typeof data.options.show_quantity_reviews == "undefined" || data.options.show_quantity_reviews == true) {
            let countView = document.createElement("span");
            countView.innerHTML = '(' + countReviews + '<span class="wr-custom-info"></span>' + ')';
            newElement.append(countView);
        }

        parent.appendChild(newElement);
    }
}

function addClassForRateCentering (options, elem) {
    let additionalClass = '';

    let filter = filterRateAppearence (elem);
    let ifFeaturedSection = checkIfFeaturedSection(elem);

    if (filter === false && (meta.page.pageType === 'product'|| ifFeaturedSection === true)) {
        if (options.rate_centering_product === "rateCenterMobile") {
            additionalClass = 'widereview-rate--center-mobile'
        } else if (options.rate_centering_product === "rateCenterAll") {
            additionalClass = 'widereview-rate--center-all'
        }
    } else {
        if (options.rate_centering_collection === "rateCenterMobile") {
            additionalClass = 'widereview-rate--center-mobile'
        } else if (options.rate_centering_collection === "rateCenterAll") {
            additionalClass = 'widereview-rate--center-all'
        }
    }

    return additionalClass;
}

//if condition=true, it means elem is inside Featured product section, compare if WR-mini is inside too
function checkIfFeaturedSection (elem) {
    let condition = false;
    let parent = elem.closest('.shopify-section');

    if (parent && parent.querySelector('.widereview-mini')) {
        condition = true;
    }
    return condition;
}

//if condition=true then elem from collection
function filterRateAppearence (elem) {
    let parent = ['ul',
        '.product-loop',                              //Avenue
        '.collection-products',
        '[data-section-type="collection-template"]',  //Avone OS
        '.related-product',
        '.product-recommendations',
        '.recent-product',
        '.productList',
        '.owl-stage',                                 //Billionaire
        '.grid--view-items',
        '.products',                                  //Bishibi
        '.product-grid',                              //Broadcast
        '.collection__products',
        '.collection-block__products',
        '.gf-row',                                    //Brooklyn
        '.cross-sell-product-page-section',           //BT Vodoma Swimwear
        '.featured-products-section',                 //Debutify
        '.linkcious-grid-wrapper',
        '.collection-list-products',
        '.gt_productlist-items',
        '[data-pf-type="Section"]',                   //Debut
        '.featured-part',                             //Dropship
        '.collection-list-part',
        '.section-featured-collection',               //Electro
        '.section-related-products',
        '.collection-template',
        '.featured-collection--section',              //Empire
        '.product-section--content',
        '.productgrid--items',
        '.collection-container',                      //Fastline
        '.scrollviews-container',
        '.collection__content',                       //Flex
        '[data-label="Product List"]',
        '[data-wetheme-section-type="collection--featured-collection"]', //Flow
        '.collection-main-body',
        '.products-carousel',                         //Halo
        '[data-section-type="collection-grid"]',      //Impulse
        '[data-section-type="featured-collection"]',  //Krunkers
        '.featured-collection',                       //Narrative
        '.tab-collections',                           //Palo Alto
        '.ProductList',                               //Prestige
        '.products-list',                             //Speedfly
        '.section-collection',
        '.section-product',
        '.grid-uniform',
        '[data-section-type="collection-row-section"]', //Supply
        '.collection',                                //Venture
        '.grid--uniform',
        '[data-section-type="home-collection"]',      //Venue
        '.product-list',                              //Warehouse
        '.product-grid-type',                         //Zeexo
        '.cata-product'
    ];

    let condition = false;
    for (let j = 0; j < parent.length; j++) {
        if (elem.closest(parent[j])) {
            condition = true;
            break;
        }
    }
    return condition;
}

function checkIfManualRate (rateList) {
    for (let i = 0; i < rateList.length; i++) {
        if (!rateList[i].hasAttribute('data-tag') ){
            rateList = checkPageBuildersConditions (rateList);
            break;
        }
    }
    return rateList;
}

function checkPageBuildersConditions (rateList) {
    const patterns = ['.gt_productlist-items',
        '[data-name="Collection"]',
        '[data-key="product-list"]',
        '.gf-carousel-loading',
        '[data-pf-type="ProductList"]',
        '.shg-category',
        '[data-section-type="product_recommendations"]',
        '.product-recommendations',
        '[data-section-type="related-products"]',
        '[data-product-recommendations]',
        '[data-section-type="featured-collection]',
        '.cont-related'];

    let newArr = [];
    for (let i = 0; i < rateList.length; i++) {
        if (!rateList[i].hasAttribute('data-tag') ){
            newArr.push(rateList[i]);
        } else {
            for (let j = 0; j < patterns.length; j++) {
                if (rateList[i].closest(patterns[j])) {
                    newArr.push(rateList[i]);
                    break;
                }
            }
        }
    }
    return newArr;
}

function removeAttributeStyle(elem) {
    elem.removeAttribute('style');
}

//delete titles margins if button 'Leave review' absent
export function checkTitlesMargin () {
    let titleContainer = document.querySelector('.widereview-header-titles');
    let btn =document.querySelector('.widereview-add_review');
    if (!btn) {
        titleContainer.style.marginLeft = 0;
    }
}

function addDynamicStyles (css, attributeName) {
    let styleTag = document.createElement("style");
    styleTag.setAttribute('dynamic-style', attributeName)

    let cssRules = css;
    styleTag.appendChild(document.createTextNode(cssRules));

    let body = document.getElementsByTagName("body")[0];
    body.appendChild(styleTag);
}

export function addHiddenContent (options, virtualCondition) {
    const container = document.getElementById('widereview-swiper-container');
    if (!container) return;
    const swiperWrapper = container.querySelector('.swiper-wrapper');
    if (!swiperWrapper) return;
    let reviewsList = container.querySelectorAll('.widereview-reviewItem');
    if (reviewsList.length === 0) return;
    if (options.add_button_more_enabled === false) return;

    for (let i = 0; i < reviewsList.length; i++) {
        let btn = reviewsList[i].querySelector(".widereview-btn-more-text");
        if (!btn) {
            btn = document.createElement('button');
            btn.setAttribute('type', 'button');
            btn.className = "widereview-btn-more-text";
            btn.innerHTML = options.add_button_more_text;
            btn.classList.add('visually-hidden');
            reviewsList[i].append(btn);
        }
        //apply original review heihgt
        reviewsList[i].style.height= 'auto';
        reviewsList[i].setAttribute('client-height', reviewsList[i].clientHeight);

        if (reviewsList[i].clientHeight > 550 && !reviewsList[i].hasAttribute('data-review-expanded')){
            btn.classList.remove('visually-hidden');
            reviewsList[i].classList.add('widereview-reviewItem--hidden-text');
            reviewsList[i].style.height= '550px';
        }

        if (+reviewsList[i].getAttribute('client-height') > +swiperWrapper.getAttribute("data-container-height")) {
            swiperWrapper.setAttribute("data-container-height", +reviewsList[i].getAttribute('client-height'));
        }

        if (parseInt(reviewsList[i].clientHeight) > +swiperWrapper.clientHeight) {
            if (virtualCondition && document.querySelector('[dynamic-style="swiper-wrapper-height"]') && !document.querySelector('[dynamic-style="swiper-wrapper-height-expanded"]')) {
                document.querySelector('[dynamic-style="swiper-wrapper-height"]').remove();
                addDynamicStyles ("#widereview-swiper-container .swiper-wrapper { height:" + reviewsList[i].clientHeight + "px !important; }", 'swiper-wrapper-height')
            }
        }
    }

    //fix swiper-wrapper height to avoid jumping with virtual slides
    if (virtualCondition && !document.querySelector('[dynamic-style="swiper-wrapper-height"]')  && !document.querySelector('[dynamic-style="swiper-wrapper-height-expanded"]')) {
        addDynamicStyles ("#widereview-swiper-container .swiper-wrapper { height:" + swiperWrapper.clientHeight + "px !important; }", 'swiper-wrapper-height')
    }

    if (!swiperWrapper.hasAttribute("data-container-height")) {
        swiperWrapper.setAttribute("data-container-height", swiperWrapper.clientHeight);
        swiperWrapper.style.height = swiperWrapper.clientHeight + "px";
    }

    if (!swiperWrapper.hasAttribute("data-max-expanded-height")) {
        swiperWrapper.setAttribute("data-max-expanded-height", swiperWrapper.clientHeight);
    }

    container.addEventListener('click', function(event) {
        event.preventDefault();
        let btn = event.target.closest('.widereview-btn-more-text');
        if (!btn) return;
        if (!container.contains(btn)) return;

        if (btn.classList.contains('visually-hidden')) return;

        let parent = btn.closest('.widereview-reviewItem--hidden-text');

        btn.classList.add('visually-hidden');

        setTimeout(function () {
            parent.classList.remove('widereview-reviewItem--hidden-text');
        }, 500);

        parent.style.height = parent.getAttribute('client-height') + 'px';
        if (parent.hasAttribute('client-height')) parent.setAttribute('data-review-expanded', true);

        let newContainerHeight = +parent.getAttribute('client-height');
        if (+swiperWrapper.getAttribute("data-max-expanded-height") < newContainerHeight) {
            swiperWrapper.setAttribute("data-max-expanded-height", newContainerHeight);
        }

        //change fixed wrapper height according the highest review
        if (virtualCondition) {
            if (document.querySelector('[dynamic-style="swiper-wrapper-height"]')) {
                document.querySelector('[dynamic-style="swiper-wrapper-height"]').remove();
            }
            if (document.querySelector('[dynamic-style="swiper-wrapper-height-expanded"]')) {
                document.querySelector('[dynamic-style="swiper-wrapper-height-expanded"]').remove()
            }

            //add animation forcontainer's anime (because of it height is fixed and not 'auto')
            swiperWrapper.style.transition = 'height 0.5s cubic-bezier(0, 0, 1, 1) 100ms, transform 0.3s  ease-out'
            addDynamicStyles ("#widereview-swiper-container .swiper-wrapper { height:" + swiperWrapper.getAttribute("data-max-expanded-height") + "px !important; }", 'swiper-wrapper-height-expanded');
        }

        parent.classList.add('widereview-reviewItem--animation');

        if (btn.closest(".swiper-slide") && btn.closest(".swiper-slide").hasAttribute('data-swiper-slide-index')) {
            let index = btn.closest(".swiper-slide").getAttribute('data-swiper-slide-index');
            let dublicates = container.querySelectorAll(`.swiper-slide[data-swiper-slide-index="${index}"]`);
            dublicates.forEach(function (elem) {
                if (elem.querySelector('.widereview-btn-more-text')) {
                    elem.querySelector('.widereview-btn-more-text').click();
                }
            })
        }
    });
};
